import { AxiosResponse } from "axios";
import { Axios } from "../Axios";
import { TypeCentroCusto } from "../../Models/Financeiro/CentroCusto";
import RequestUtilitario, { BasicQueryType } from "../../Utils/RequisicaoUtilitario";
import { useQuery } from "@tanstack/react-query";

export class CentroCustoService {
    public listar(centro: TypeCentroCusto): Promise<AxiosResponse<TypeCentroCusto[]>> {
        return Axios.post<TypeCentroCusto[]>(`CentroCusto/listar`, centro);
    }
    public inserir(centro: TypeCentroCusto){
        return Axios.post<boolean>(`CentroCusto/inserir`, centro);
    }

    public atualizar(centro: TypeCentroCusto){
        return Axios.post<boolean>(`CentroCusto/atualizar`, centro);
    }

    public desativar(codigo: number){
        return Axios.post<boolean>(`CentroCusto/desativar/${codigo}`);
    }

    public ativar(codigo: number){
        return Axios.post<boolean>(`CentroCusto/ativar/${codigo}`);
    }
}

export function useCentroCustoListar ({
    centroCusto,
    ...rest
}:BasicQueryType<AxiosResponse<TypeCentroCusto[]>, {
    centroCusto?:TypeCentroCusto
}>) {
    const centroCustoService = new CentroCustoService();

    return useQuery({
        ...rest,
        queryKey : [ "Financeiro.CentroCusto.Listar" ],
        queryFn : () => centroCustoService.listar(centroCusto ?? {}),
        select : ({data}) => data
    });
}

export function useCentroCustoListarValidos ({
    centroCusto,
    fechado,
    codCentroCustoInvalidarFiltro,
    ...rest
}:BasicQueryType<AxiosResponse<TypeCentroCusto[]>, {
    centroCusto?:TypeCentroCusto,
    fechado?:boolean,
    codCentroCustoInvalidarFiltro?:Array<number>
}>) {
    var queryString = RequestUtilitario.objectToQueryString({
        filtro: centroCusto ?? {},
        fechado: fechado ?? null,
        codCentroCustoInvalidarFiltro: codCentroCustoInvalidarFiltro ?? []
    });

    console.log("useCentroCustoListarValidos queryString: ", queryString);

    return useQuery({
        ...rest,
        queryKey : [ "Financeiro.CentroCusto.ListarValidos", `Financeiro.CentroCusto.ListarValidos?${queryString}` ],
        queryFn : () => Axios.get<TypeCentroCusto[]>(`domain/financeiro/CentroCusto?${queryString}`),
        select : ({data}) => data
    });
}

export default {
    useCentroCustoListar
}